import { useConnectedClient } from 'context/ConnectedClientContext';

export const useIsAiModeratedStudyEnabled = (): boolean => {
  const { details } = useConnectedClient();

  return !!details?.ConnectedTeam?.products?.track_add_ons?.ai_mod;
};
